if (typeof ShippingCalculator !== 'function') {
  class ShippingCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      window.setTimeout(() => {
        const estimateShipping = this.querySelector('.js-estimate-shipping');
        const country = this.querySelector('[name="country"]');
        const province = this.querySelector('[name="province"]');
        const zip = this.querySelector('[name="zip"]');
        const resultsBlock = this.querySelector('.shipping-estimator__results');
        const resultsBlockContent = this.querySelector('.shipping-estimator__results-content');
        const resultsBlockContentList = this.querySelector('.shipping-estimator__results-content ul');
        const resultsBlockContentHeading = this.querySelector('.shipping-estimator__results-content-heading');
        const resultsErrors = this.querySelector('.alert');

        if (
          !estimateShipping ||
          !country ||
          !province ||
          !zip ||
          !resultsBlock ||
          !resultsBlockContent ||
          !resultsBlockContentList ||
          !resultsBlockContentHeading ||
          !resultsErrors
        ) return;

        this.dataset.initialized = 'true';

        new Shopify.CountryProvinceSelector(
          'shipping-estimator-country',
          'shipping-estimator-province',
          {
            hideElement: 'address_province_container'
          }
        );

        estimateShipping.addEventListener('click', async (event) => {
          event.preventDefault();
          resultsBlockContentList.innerHTML = '';

          const params = new URLSearchParams({
            'shipping_address[zip]': zip.value,
            'shipping_address[country]': country.value,
            'shipping_address[province]': province.value
          });

          try {
            const response = await fetch(
              `${KROWN.settings.routes.cart_url}/shipping_rates.json?${params.toString()}`,
              {
                credentials: 'same-origin',
                method: 'GET'
              }
            );

            const result = await response.json();

            if (!response.ok || !result.shipping_rates) {
              resultsBlockContent.style.display = 'none';
              resultsBlock.style.display = 'block';
              resultsErrors.style.display = 'block';
              resultsErrors.innerHTML = '';

              Object.values(result).forEach((message) => {
                resultsErrors.insertAdjacentHTML(
                  'beforeend',
                  `<li>${message}</li>`
                );
              });

              return;
            }

            const rates = result.shipping_rates;

            resultsErrors.style.display = 'none';
            resultsBlock.style.display = 'block';
            resultsBlockContent.style.display = 'block';

            resultsBlockContentHeading.textContent =
              rates.length === 1
                ? KROWN.settings.locales.shipping_calculator_results_heading_one
                : KROWN.settings.locales.shipping_calculator_results_heading_multiple;

            rates.forEach((rate) => {
              resultsBlockContentList.insertAdjacentHTML(
                'beforeend',
                `<li>${rate.presentment_name}: ${this.formatMoney(
                  rate.price,
                  KROWN.settings.shop_money_format
                )}</li>`
              );
            });
          } catch (error) {
            resultsBlockContent.style.display = 'none';
            resultsBlock.style.display = 'block';
            resultsErrors.style.display = 'block';
            resultsErrors.textContent = error.message;
          }
        });

        country.addEventListener('change', () => {
          resultsBlock.style.display = 'none';
        });
      }, 0);
    }

    formatMoney(cents, format) {
      const normalizedCents =
        typeof cents === 'string' ? cents.replace('.', '') : cents;

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '${{amount}}';

      const formatWithDelimiters = (
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
      ) => {
        if (Number.isNaN(Number(number)) || number === null) return '0';

        const parts = (Number(number) / 100)
          .toFixed(precision)
          .split('.');

        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );

        return `${dollars}${parts[1] ? `${decimal}${parts[1]}` : ''}`;
      };

      const placeholder = formatString.match(placeholderRegex)?.[1];
      let value = formatWithDelimiters(normalizedCents);

      if (placeholder === 'amount_no_decimals') {
        value = formatWithDelimiters(normalizedCents, 0);
      }

      if (placeholder === 'amount_with_comma_separator') {
        value = formatWithDelimiters(normalizedCents, 2, '.', ',');
      }

      if (placeholder === 'amount_no_decimals_with_comma_separator') {
        value = formatWithDelimiters(normalizedCents, 0, '.', ',');
      }

      if (placeholder === 'amount_no_decimals_with_space_separator') {
        value = formatWithDelimiters(normalizedCents, 0, ' ');
      }

      if (placeholder === 'amount_with_apostrophe_separator') {
        value = formatWithDelimiters(normalizedCents, 2, "'");
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (!customElements.get('shipping-calculator')) {
    customElements.define('shipping-calculator', ShippingCalculator);
  }
}